import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';
import { useNavigate, useLocation } from 'react-router-dom';
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDTypography from 'components/MDTypography';
import DataTable from 'examples/Tables/DataTable';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Footer from 'examples/Footer';
import MDPagination from 'components/MDPagination';
import { apiGetNoticesTitle } from '../../api/notice.api';
import { useData } from '../../hooks';

const Manual = () => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, appIsReady } = useData();
  const messageType = 5; // messageType is fixed to 5

  useEffect(() => {
    if (appIsReady && user) {
      fetchNotices(page, messageType);
    }
  }, [page, user, appIsReady]);

  const fetchNotices = async (pageNum, messageType) => {
    setLoading(true);
    try {
      const response = await apiGetNoticesTitle(
        pageNum,
        10,
        messageType,
        user.accessToken,
      );
      if (response && response.data) {
        const filteredNotices = response.data.filter(
          (notice) => notice.orderno === 1,
        );
        setNotices(filteredNotices);
        setTotal(response.total);
      } else {
        console.log('No data received');
      }
    } catch (error) {
      console.error('Failed to load notices:', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (pageNum) => {
    setPage(pageNum);
  };

  const handleRowClick = (noticeData) => {
    console.log('handlRowClick');
    navigate(`/manual/detail/`, {
      state: { messageType, subType: noticeData.subType, page },
    });
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return new Date(dateString)
      .toLocaleString('ko-KR', options)
      .replace(/. /g, '-')
      .replace('.', '')
      .replace(' ', ' ')
      .slice(0, 10);
  };

  const rows = notices.map((notice) => ({
    original: notice,
    id: notice.id ? notice.id.toString() : '', // 숫자를 문자열로 변환
    title: notice.title || '', // null 체크
    subType: notice.subType || '', // null 체크
    createdAt: notice.createdAt ? formatDate(notice.createdAt) : '', // null 체크
  }));

  const columns = [
    { Header: '제목', accessor: 'title', align: 'left' },
    { Header: '작성일', accessor: 'createdAt', align: 'left' },
  ];

  // 페이지 번호 계산
  const totalPages = Math.ceil(total / 10);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant='gradient'
                bgColor='info'
                borderRadius='lg'
                coloredShadow='info'
              >
                <MDTypography variant='h6' color='white'>
                  매뉴얼
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                  loading={loading}
                  onRowClick={(row) => handleRowClick(row.original)}
                />
              </MDBox>
              <MDBox
                display='flex'
                flexDirection={{ xs: 'column', sm: 'row' }}
                justifyContent='center'
                alignItems={{ xs: 'flex-start', sm: 'center' }}
                p={3}
              >
                <MDPagination variant='gradient' color='info'>
                  {page > 1 && (
                    <MDPagination
                      item
                      onClick={() => handlePageChange(page - 1)}
                    >
                      <Icon sx={{ fontWeight: 'bold' }}>chevron_left</Icon>
                    </MDPagination>
                  )}
                  {Array.from({ length: totalPages }, (_, index) => (
                    <MDPagination
                      item
                      key={index}
                      onClick={() => handlePageChange(index + 1)}
                      active={page === index + 1}
                    >
                      {index + 1}
                    </MDPagination>
                  ))}
                  {page < totalPages && (
                    <MDPagination
                      item
                      onClick={() => handlePageChange(page + 1)}
                    >
                      <Icon sx={{ fontWeight: 'bold' }}>chevron_right</Icon>
                    </MDPagination>
                  )}
                </MDPagination>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default Manual;
